'use client';

import { useCallback } from 'react';
import { toast } from './toast';

// ----------------------------------------------------------------------

type SnackbarOptions = {
    variant?: 'default' | 'error' | 'success' | 'warning' | 'info';
    [key: string]: any;
};

export function useSnackbar() {
    const enqueueSnackbar = useCallback((message: string, options?: SnackbarOptions) => {
        const { variant = 'default', ...other } = options || {};

        if (variant === 'default') {
            return toast(message, other);
        }

        if (variant === 'error') {
            return toast.error(message, other);
        }

        if (variant === 'success') {
            return toast.success(message, other);
        }

        if (variant === 'warning') {
            return toast.warning(message, other);
        }

        if (variant === 'info') {
            return toast.info(message, other);
        }
    }, []);

    return { enqueueSnackbar };
}

